/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import ConfirmationModal from "ae-base/Base/ConfirmationModal";

import { useResources } from "@aetonix/hooks";

export default function WanderValidation(props) {
	const {
		localize,
		dispatch,
	} = useResources();

	// Parameters for wander banner confirmation
	var wanderinvalidator = props.wanderinvalidator;
	var fromID = props.from;

	var confirmationQuestion = localize("banner.wanderFalseAlarmQuestion");
	var answerYes = localize("common.yes");
	var answerNo = localize("common.no");
	var onConfirm = dispatch("wanderinvalidator:trigger:cancel");
	var onDeny = dispatch("wanderinvalidator:trigger:confirm", {
		from: fromID,
	});

	return (
		<ConfirmationModal
			open={wanderinvalidator}
			title={confirmationQuestion}
			titleIcon={"exclamation-triangle"}
			confirmText={answerYes}
			cancelText={answerNo}
			onConfirm={onConfirm}
			onCancel={onDeny} />
	);
}
